import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const useCloudPricingState = () => {
  const api = useApi()

  const query = useQuery({
    queryKey: ['batch-executor', 'cloud-pricing', 'state'],
    queryFn: () => api.batchExecutor.cloudPricing.getState({ instance_tag: 'AWS_INSTANCE_X' }),
    refetchInterval: 10_000,
  })

  type CloudStatus =
    'PENDING' | 'RUNNING' | 'SHUTTING_DOWN' | 'TERMINATED' | 'STOPPING' | 'STOPPED' | 'ERROR'

  const statusMap = {
    0: 'PENDING',
    16: 'RUNNING',
    32: 'SHUTTING_DOWN',
    48: 'TERMINATED',
    64: 'STOPPING',
    80: 'STOPPED',
  } as const

  const cloudPricingStatus: CloudStatus = query.data !== undefined ? statusMap[query.data] : 'ERROR'

  return {
    query,
    cloudPricingStatus,
    isActive: cloudPricingStatus === 'RUNNING',
  }
}
